import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import * as resources from "./resources";

var LocalizationClass =
/*#__PURE__*/
function () {
  function LocalizationClass(lang) {
    var _this = this;

    _classCallCheck(this, LocalizationClass);

    this.texts = LocalizationClass._fallback.texts;
    this.formats = LocalizationClass._fallback.formats;

    this.refresh = function () {
      _newArrowCheck(this, _this);

      this.setLanguage(this.lang || LocalizationClass.getBrowserLanguage());
    }.bind(this);

    this.setLanguage = function (lang) {
      _newArrowCheck(this, _this);

      var resourceKeyParts = typeof lang !== "undefined" && typeof lang.split === "function" && lang.split("-");
      var resourceKeyParent = typeof resourceKeyParts !== "undefined" && resourceKeyParts[0];
      var resourceKey = typeof resourceKeyParts !== "undefined" && typeof resourceKeyParts.join === "function" && resourceKeyParts.join("_"); // TODO use _.set and _.merge

      this.texts = LocalizationClass.deepMerge({}, LocalizationClass._fallback.texts, resources[resourceKeyParent] && resources[resourceKeyParent].texts || {}, resources[resourceKey] && resources[resourceKey].texts || {}, typeof window !== "undefined" && window.lsgTranslations && window.lsgTranslations.texts || {});
      this.formats = Object.assign(Object.assign(Object.assign(Object.assign({}, LocalizationClass._fallback.formats), resources[resourceKeyParent] && resources[resourceKeyParent].formats || {}), resources[resourceKey] && resources[resourceKey].formats || {}), typeof window !== "undefined" && window.lsgTranslations && window.lsgTranslations.formats || {});
    }.bind(this);

    this.getIconTitle = function (name, noDefault) {
      _newArrowCheck(this, _this);

      return this.texts && this.texts.lsg.icon[name] || !noDefault && this.texts && this.texts.lsg.icon._default;
    }.bind(this);

    this.withField = function (text, fields) {
      var _this2 = this;

      _newArrowCheck(this, _this);

      return typeof Object.entries(fields).reduce === "function" && typeof Object.entries(fields).reduce(function (acc, entry) {
        _newArrowCheck(this, _this2);

        var searchString = "{{".concat(entry[0], "}}");
        var replaceString = typeof entry[1] === "number" || typeof entry[1] === "string" ? entry[1] : "";
        return typeof acc.replace === "function" && acc.replace(searchString, replaceString);
      }.bind(this), text).replace === "function" && Object.entries(fields).reduce(function (acc, entry) {
        _newArrowCheck(this, _this2);

        var searchString = "{{".concat(entry[0], "}}");
        var replaceString = typeof entry[1] === "number" || typeof entry[1] === "string" ? entry[1] : "";
        return typeof acc.replace === "function" && acc.replace(searchString, replaceString);
      }.bind(this), text).replace(/{{.*}}/g, "");
    }.bind(this);

    this.lang = lang;
    this.refresh();
  }

  _createClass(LocalizationClass, null, [{
    key: "getBrowserLanguage",
    value: function getBrowserLanguage() {
      return typeof document !== "undefined" && document.documentElement.getAttribute("lang") || typeof navigator !== "undefined" && navigator.language || "en";
    } // convert a flat string with dots as a separator to a deep object
    // e.g. ('icon.arrow', 'Some description') is converted to {icon: {arrow: 'Some description'}}

  }, {
    key: "deepen",
    value: function deepen(name, value) {
      var _this3 = this;

      return name.split(".").reverse().reduce(function (acc, val) {
        _newArrowCheck(this, _this3);

        return _defineProperty({}, val, acc);
      }.bind(this), value);
    } // deep merge of objects
    // e.g. ({icons: {arrow: '->'}}, {icons: {info: 'i'}}, {'icons.plus': '+'})
    // is converted to {icons: {arrow: '->', info: 'i', plus: '+'}}

  }, {
    key: "deepMerge",
    value: function deepMerge(target) {
      var _this4 = this;

      var additionalSources = [];

      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      sources.forEach(function (source) {
        var _this5 = this;

        _newArrowCheck(this, _this4);

        Object.keys(source).forEach(function (key) {
          _newArrowCheck(this, _this5);

          var sourceValue = source[key];
          var targetValue = target[key];

          if (key.includes(".")) {
            var sourceMerged = LocalizationClass.deepen(key, sourceValue);
            additionalSources.push(sourceMerged);
          } else if ((targetValue === undefined || _typeof(targetValue) === "object") && _typeof(sourceValue) === "object") {
            target[key] = LocalizationClass.deepMerge(targetValue || {}, sourceValue);
          } else if (_typeof(targetValue) !== "object" && _typeof(sourceValue) !== "object") {
            target[key] = sourceValue;
          } else {// console.warn("custom translation does not match the expected format");
          }
        }.bind(this));
      }.bind(this));

      if (additionalSources.length > 0) {
        return LocalizationClass.deepMerge.apply(LocalizationClass, [target].concat(additionalSources));
      }

      return target;
    }
  }]);

  return LocalizationClass;
}();

LocalizationClass._fallback = resources.de;
var Localization = new LocalizationClass();
export { Localization, LocalizationClass };